<!-- Skeleton -->
@if (loading) {
  <div class="skeleton-container">
    <div class="skeleton-header-detail"></div>
    <div class="skeleton-content-detail">
      <div class="skeleton-main"></div>
      <div class="skeleton-sidebar"></div>
    </div>
  </div>
}

@if (role && !loading) {
  <div class="role-detail-container">
    <!-- Header -->
    <div class="detail-header">
      <button mat-icon-button (click)="goBack()" class="back-button" matTooltip="Retour">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1>Détails du rôle</h1>
    </div>
    <!-- Contenu -->
    <div class="detail-content">
      <!-- Carte principale -->
      <mat-card class="main-card">
        <!-- Avatar et titre -->
        <div class="role-header">
          <div class="avatar-large" [style.background-color]="getAvatarColor()">
            {{ getInitials() }}
          </div>
          <div class="role-title-section">
            <h2 class="role-title">{{ role.title || role.name }}</h2>
            <mat-chip class="role-type-chip" [style.background-color]="getRoleTypeColor()">
              <mat-icon class="chip-icon">{{ getRoleTypeIcon() }}</mat-icon>
              <span>{{ getRoleType() }}</span>
            </mat-chip>
          </div>
        </div>
        <!-- Actions -->
        <div class="action-buttons">
          <button mat-raised-button color="primary" (click)="editRole()" class="action-btn">
            <mat-icon>edit</mat-icon>
            Modifier
          </button>
          <button mat-raised-button color="warn" (click)="openDeleteDialog()" class="action-btn">
            <mat-icon>delete</mat-icon>
            Supprimer
          </button>
        </div>
        <!-- Informations principales -->
        <div class="info-section">
          <h3 class="section-title">
            <mat-icon class="section-icon">info</mat-icon>
            Informations générales
          </h3>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">
                <mat-icon class="info-icon">label</mat-icon>
                Nom (identifiant)
              </div>
              <div class="info-value">{{ role.name }}</div>
            </div>
            @if (role.title) {
              <div class="info-item">
                <div class="info-label">
                  <mat-icon class="info-icon">title</mat-icon>
                  Libellé
                </div>
                <div class="info-value">{{ role.title }}</div>
              </div>
            }
            @if (!isRealmRole) {
              <div class="info-item">
                <div class="info-label">
                  <mat-icon class="info-icon">apps</mat-icon>
                  Application cliente
                </div>
                <div class="info-value">{{ clientName }}</div>
              </div>
            }
            @if (isRealmRole) {
              <div class="info-item">
                <div class="info-label">
                  <mat-icon class="info-icon">language</mat-icon>
                  Portée
                </div>
                <div class="info-value">
                  <span class="realm-badge">
                    <mat-icon class="small-icon">public</mat-icon>
                    Global (Realm)
                  </span>
                </div>
              </div>
            }
            @if (role.description) {
              <div class="info-item full-width">
                <div class="info-label">
                  <mat-icon class="info-icon">description</mat-icon>
                  Description
                </div>
                <div class="info-value">{{ role.description }}</div>
              </div>
            }
          </div>
        </div>
        <!-- Propriétés -->
        <div class="info-section">
          <h3 class="section-title">
            <mat-icon class="section-icon">settings</mat-icon>
            Propriétés
          </h3>
          <div class="properties-grid">
            <div class="property-card" [class.active]="role.composite">
              <div class="property-icon" [class.active]="role.composite">
                <mat-icon>{{ role.composite ? 'check_circle' : 'cancel' }}</mat-icon>
              </div>
              <div class="property-content">
                <div class="property-label">Rôle composite</div>
                <div class="property-value">{{ role.composite ? 'Oui' : 'Non' }}</div>
                @if (role.composite) {
                  <div class="property-description">
                    Ce rôle peut contenir d'autres rôles
                  </div>
                }
              </div>
            </div>
            <div class="property-card" [class.active]="role.clientRole">
              <div class="property-icon" [class.active]="role.clientRole">
                <mat-icon>{{ role.clientRole ? 'check_circle' : 'cancel' }}</mat-icon>
              </div>
              <div class="property-content">
                <div class="property-label">Rôle client</div>
                <div class="property-value">{{ role.clientRole ? 'Oui' : 'Non' }}</div>
                @if (role.clientRole) {
                  <div class="property-description">
                    Spécifique à une application
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <!-- Informations techniques -->
        <!-- <div class="info-section">
        <h3 class="section-title">
          <mat-icon class="section-icon">code</mat-icon>
          Informations techniques
        </h3>
        <div class="tech-info">
          <div class="tech-item">
            <span class="tech-label">Container ID:</span>
            <code class="tech-value">{{ role.containerId || 'N/A' }}</code>
          </div>
        </div>
      </div> -->
    </mat-card>
    <!-- Sidebar -->
    <div class="sidebar-cards">
      <mat-card class="stats-card">
        <h3 class="card-title">
          <mat-icon class="title-icon">analytics</mat-icon>
          Statistiques
        </h3>
        <div class="stats-content">
          <div class="stat-item">
            <div class="stat-icon">
              <mat-icon>group</mat-icon>
            </div>
            <div class="stat-details">
              <div class="stat-value">-</div>
              <div class="stat-label">Utilisateurs</div>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-icon">
              <mat-icon>groups</mat-icon>
            </div>
            <div class="stat-details">
              <div class="stat-value">-</div>
              <div class="stat-label">Groupes</div>
            </div>
          </div>
        </div>
      </mat-card>
      <mat-card class="quick-actions-card">
        <h3 class="card-title">
          <mat-icon class="title-icon">flash_on</mat-icon>
          Actions rapides
        </h3>
        <div class="quick-actions">
          <button mat-stroked-button class="quick-action-btn" (click)="editRole()">
            <mat-icon>edit</mat-icon>
            <span>Modifier le rôle</span>
          </button>
          <button mat-stroked-button class="quick-action-btn danger" (click)="openDeleteDialog()">
            <mat-icon>delete</mat-icon>
            <span>Supprimer</span>
          </button>
        </div>
      </mat-card>
    </div>
  </div>
</div>
}